import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import { lightTheme as theme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { ChipStyled, MoneyWrapperStyled } from '../CheckDepositSubmissionOverview.styles';

const statuses = {
  pending: {
    text: 'Pending',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.orange.main
  },
  processing: {
    text: 'Processing',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.orange.main
  }
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

const SummaryMoney = ({ amount, type }) => {
  const { text, color, backgroundColor } = statuses[type];
  const formattedAmount = formatter.format(amount / 100);

  return (
    <MoneyWrapperStyled>
      <Text
        size="md"
        weight="medium"
      >
        Deposit amount
      </Text>
      <Heading
        size="5xl"
        weight="bold"
      >
        {formattedAmount}
      </Heading>
      <Box
        position="absolute"
        right={24}
        top={16}
      >
        <ChipStyled
          backgroundColor={backgroundColor}
          color={color}
        >
          {text}
        </ChipStyled>
      </Box>
    </MoneyWrapperStyled>
  );
};

SummaryMoney.propTypes = {
  amount: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['pending', 'processing']).isRequired
};

export default SummaryMoney;
